// libs
import { styled } from '@nykaa/ui-components';
import { BREAKPOINTS, FOCUS_VISIBILITY_CSS } from 'shared/styles/base';

export const Container = styled.div`
  width: 100%;
  height: 32px;
  align-items: center;
  display: flex;
  ${({ theme }) => `margin: ${theme.spacing.spacing60} 0 0 0;
  `};
  .user-help-count {
    ${({ theme }) => theme.typography.bodySmall};
    flex: 1 1 0;
  }
`;

export const Title = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme }) => `padding: 0 ${theme.spacing.spacing40} 0 0;
  border-radius: ${theme.borders.buttonBorderRadius};
  color: ${theme.colors.textPrimary};
  margin:  0 ${theme.spacing.spacing40} 0 0;
  padding: ${theme.spacing.spacing40};
  border: 1px solid ${theme.colors.textOutline};`};
  display: flex;
  background: none;

  ${({ theme }) => theme.typography.buttonSmall};
  cursor: pointer;
  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    border-radius: ${({ theme }) => theme.borders.mwebButtonBorderRadius};
  }

  ${FOCUS_VISIBILITY_CSS}
`;

export const IconWrapper = styled.span`
  display: flex;
  ${({ theme }) => `
  color: ${theme.colors.textSecondary};`}
  ${({ theme }) => `padding: 0px ${theme.spacing.spacing40} 0px 0px`};
`;

export const Description = styled.span`
  color: ${({ theme }) => theme.colors.textSecondary};
  ${({ theme }) => theme.typography.bodySmall};
`;

export const HelpfulText = styled.span`
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.buttonSmall};
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.buttonMedium};
  }
`;
